function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 2.923,
    y: 29.449,
    width: 65.904,
    height: 3.374,
    style: {
      strokeLinejoin: "bevel",
      strokeLinecap: "round",
      strokeWidth: 9,
      vectorEffect: "non-scaling-stroke",
      paintOrder: "fill",
      stroke: "rgb(0, 0, 0)",
      opacity: 1,
      transformOrigin: "35.875px 31.137px"
    },
    rx: 9.096,
    ry: 9.096,
    transform: "matrix(0.708133995533, 0.706077873707, -0.708136975765, 0.706080913544, -11.11454635686, -6.051199238656)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.923,
    y: 29.449,
    width: 65.904,
    height: 3.374,
    style: {
      strokeLinejoin: "bevel",
      strokeLinecap: "round",
      strokeWidth: 9,
      vectorEffect: "non-scaling-stroke",
      paintOrder: "fill",
      stroke: "rgb(0, 0, 0)",
      opacity: 1,
      transformOrigin: "35.875px 31.137px"
    },
    rx: 9.096,
    ry: 9.096,
    transform: "matrix(0.708133995533, -0.706077873707, 0.708136975765, 0.706080913544, -10.909412400671, -6.250252116569)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.97095bfbcebbbed61cb389a9917b3108.svg";
export { ForwardRef as ReactComponent };